import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Box } from "@mui/material";

const FeedbackModal = ({
  open,
  title,
  message,
  onClose,
  type, // "success", "error", or "info"
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color={type === "error" ? "error" : "primary"}
          variant="contained"
          style={{ background: "#ED141F" }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackModal;
